import { esriQuery } from 'js/utils/esriQueries';

export const query_state_zone = (geometry, load) => {
  const url = load.layers.queryDictionary.stateZoneURL;
  const options = {
    geometry,
    outFields: ['*'],
  };
  return esriQuery(url, options);
};

export const query_pr_usvi_zone = (geometry, load) => {
  const url = load.layers.queryDictionary.usviZoneURL;
  const options = {
    geometry,
    outFields: ['*'],
  };
  return esriQuery(url, options);
};
